var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackgroundGrid = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 480,
  height: 480,
  fill: "none",
  viewBox: "0 0 480 480",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 480,
  height: 480,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M0 0h480v480H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#c)",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5 0v480M32.5 0v480M64.5 0v480M96.5 0v480M128.5 0v480M160.5 0v480M192.5 0v480M224.5 0v480M256.5 0v480M288.5 0v480M320.5 0v480M352.5 0v480M384.5 0v480M416.5 0v480M448.5 0v480"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h479v479H.5z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 31.5h480M0 63.5h480M0 95.5h480M0 127.5h480M0 159.5h480M0 191.5h480M0 223.5h480M0 255.5h480M0 287.5h480M0 319.5h480M0 351.5h480M0 383.5h480M0 415.5h480M0 447.5h480M0 479.5h480"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h479v479H.5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h480v480H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h480v480H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h480v480H0z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(90 0 240)scale(240)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background-grid.128817801304e5332536c790cc32b257.svg";